import React, { useEffect, useMemo, useState } from "react";
import { CardTitle, Card, Input } from "reactstrap";

import { ViewOfTheRoom } from "../../api";
import BarChart from "./ValueInTheRoomBarChart";
import ColumnChart from "./ValueInTheRoomColumnChart";
import PieChart from "./ValueInTheRoomPieChart";
import List from "./ValueInTheRoomList";

interface ValueInTheRoomProps {
  data: ViewOfTheRoom[];
}

const ValueInTheRoom = ({ data }: ValueInTheRoomProps) => {

  const [viewName, setViewName] = useState<string>();

  const view = useMemo<ViewOfTheRoom | undefined>(() => {
    const view = data.filter(x => x.name === viewName)[0];
    return view;
  }, [data, viewName]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setViewName(e.target.value);
  };

  useEffect(() => {
    if (data && data.length && (!viewName || !data.some(x => x.name === viewName))) {
      setViewName(data[0].name);
    }
  }, [data]);

  return (
    <Card className="c-vitr">
      <CardTitle
        tag="h5"
        className="mt-3 text-primary text-center text-uppercase fs-9 fw-6"
      >
        VIEW OF THE ROOM
      </CardTitle>

      <div style={{ minHeight: "3rem" }}>
        {!!data && data.length !== 0 && !!viewName && (
          <>
            {/* Select */}
            <div className="pl-2 pr-2 pb-2">
              <Input type="select" className="text-secondary" value={viewName} onChange={onChange}>
                {data.map((view, index) => (
                  <option key={index} value={view.name}>
                    {view.name}
                  </option>
                ))}
              </Input>
            </div>

            {/* Data */}
            {!!view && (
              <>
                {1 < view.data[0].values.length
                  ? view.data.length < 5
                    ? (<BarChart view={view} />)
                    : (<ColumnChart view={view} />)
                  : typeof view.total === "number"
                    ? (<PieChart view={view} />)
                    : (<List view={view} />)
                }
              </>
            )}
          </>
        )}
      </div>
    </Card>
  );
};

export default ValueInTheRoom;
